import masterdataStore from './store'

export default class MasterdataModule {
  name = 'masterdata'
  constructor({ store }) {
    store.registerModule(this.name, masterdataStore)
  }
}
